import { Component, Input, TemplateRef } from '@angular/core';
import { BaseViewComponent } from '@sb/library/base';

@Component({
    selector: 'lib-chip-preview',
    templateUrl: './form-field-chip-preview.component.html',
    styleUrls: ['./form-field-chip-preview.component.scss']
})
export class ChipPreviewComponent<T> extends BaseViewComponent {
    @Input() data!: T;
    @Input() chipPreviewContentTemplate!: TemplateRef<any>;

}
